import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import logo from "../../assets/img/Fronic_logo_black.png"
import { useNavigate } from "react-router-dom"
import { saveObject, toastError } from '../../utils';
import LoginFormValidate from './LoginFormValidate';
import { CircularProgress, Hidden } from '@mui/material';
import { adminLogin } from "./actions";
import loginScreen from "../../assets/img/loginScreen.jpg"
import FullScreenLoader from '../Common/FullScreenLoader';

export default function Login() {
    const navigate = useNavigate();
    const [user, setUser] = useState({
        email: '',
        password: ''
    })
    const [errors, setErrors] = useState({})
    const [imageLoader, setImageLoader] = useState(true);
    const [loginLoader, setLoginLoader] = useState(false)

    const onChangeHandler = ({ target: { value = '', name = '' } }) => {
        setUser({ ...user, [name]: value })
        setErrors({ ...errors, [name]: '' })
    }

    const onSubmit = (e) => {
        e.preventDefault()
        if (loginLoader) return
        const { errors, isValid } = LoginFormValidate(user)
        setErrors(errors);
        if (isValid) {
            setLoginLoader(true)
            adminLogin(user).then((res) => {
                setLoginLoader(false)
                saveObject('auth', res.token)
                return navigate('/')
            }).catch((err) => {
                setLoginLoader(false)
                toastError(err.message || 'Something went wrong')

            })
        }
    }

    return (
        <>
            <FullScreenLoader open={loginLoader} />
            <Grid
                container
                component="main"
                className="login-container"
                sx={{ height: '100vh' }}
            >
                <CssBaseline />
                <Hidden only={['xs']}>
                    <Grid
                        item
                        xs={false}
                        sm={4}
                        md={7}
                        sx={{
                            width: '100%',
                            height: '100vh'
                        }}
                    >
                        <img
                            src={loginScreen}
                            alt=''
                            onLoad={() => setImageLoader(false)}
                            style={{
                                width: '100%',
                                height: "100%",
                                objectFit: "cover"
                            }}
                        />
                    </Grid>
                </Hidden>
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div className="login-logo-div">
                            <img src={logo} alt="logo" />
                        </div>
                        <Box
                            component="form"
                            className="form-container"
                            onSubmit={onSubmit}
                            noValidate
                            sx={{
                                width: '100%',
                                mt: 1
                            }}
                        >
                            <TextField
                                type="text"
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                error={errors && errors.email ? !!errors.email : !!''}
                                value={user.email}
                                onChange={onChangeHandler}
                                autoComplete="email"
                                autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                error={errors && errors.password ? !!errors.password : !!''}
                                value={user.password}
                                onChange={onChangeHandler}
                                autoComplete="current-password"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    height: 50
                                }}
                                onClick={onSubmit}
                            >
                                Login
                            </Button>
                            <Grid container>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </>

    );
}